export const CARDS_PER_PAGE_TABLET = 3;
export const CARDS_PER_PAGE_DESKTOP = 4;
